module.exports = __webpack_public_path__ + "img/icon_footer_sport_basketball_selected.62cbaddc.png";